export default {
  form: {
    font_family: {
      label: 'Família de fontes',
    },
    header: {
      label: 'Cabeçalho',
      placeholder: 'Cabeçalho',
    },
    sub_header: {
      label: 'Subcabeçalho',
      placeholder: 'Subcabeçalho',
    },
    footer: {
      label: 'Texto do rodapé',
      placeholder: 'Introduza o texto do rodapé',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Selecionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Cor primária',
    },
    background_color: {
      label: 'Cor de fundo',
    },
    cover_image: {
      label: 'Imagem de capa',
    },
    logo: {
      label: 'Logótipo',
    },
    logo_zoom: {
      label: 'Zoom do logótipo',
    },
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar o autocolante de porta',
  },
};
